var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"news-page",attrs:{"fluid":""}},_vm._l((_vm.news_list),function(news_card){return _c('v-row',{key:news_card.id,attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"6"}},[_c('news-card',{attrs:{"data":news_card}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }